/**
 * Modelo da página da experiência escolhida: o que mostrar do resgate gravado
 * (`find/resgate_experiencias`, campo `extra`, que é a cópia do cartão no momento da escolha).
 */

import { stripCatalogPrefix } from 'utils/experience-catalog';

import { nomeDaExperiencia, paginasDeRegras, TipoDaExperiencia } from '../catalogo-modelo';

export interface ExperienciaEscolhida {
  tipo: TipoDaExperiencia;
  /**
   * O NOME curto, como o cartão e o modal de cancelar o dizem (D-14): a premiação isolada pelo
   * tipo e valor, o combo pelo título sem o prefixo de catalogação.
   */
  nome: string;
  /** A FRASE da escolha: no combo, a que o motor calcula com o complemento; senão, o título sem prefixo. */
  escolha: string;
  /** Quantidade antes da escolha em "Experiência confirmada:": o valor nos pontos, o total nos dias. */
  quantidade?: string;
  /** "valor: R$ {valor}", só no cartão. */
  valorDoCartao?: string;
  descricao?: string;
  aviso?: string;
  imagem?: string;
  data?: Date;
  regras: string[];
}

export function montarExperienciaEscolhida(resgate: any): ExperienciaEscolhida | null {
  const extra = resgate?.extra;
  if (!extra) return null;

  const tipoDoItem: string = extra.type || '';
  const titulo = stripCatalogPrefix(extra.title || '');
  const frase = tipoDoItem === 'combo' ? extra.description : '';
  const nome = nomeDaExperiencia(tipoDoItem, extra.title, extra.valor);

  return {
    tipo: tipoDoItem === 'combo' ? 'combo' : 'unico',
    nome,
    escolha: frase || titulo,
    quantidade:
      tipoDoItem === 'pontos_Livelo' && extra.valor ? String(extra.valor) : tipoDoItem === 'dias_livres' && extra.total ? String(extra.total) : undefined,
    valorDoCartao: tipoDoItem === 'cartao' && extra.valor ? `R$ ${extra.valor}` : undefined,
    descricao: extra.description || undefined,
    aviso: extra.aviso || undefined,
    imagem: extra.image || undefined,
    data: resgate.time ? new Date(resgate.time) : undefined,
    regras: paginasDeRegras(extra.regrasDeUso),
  };
}

/** "1S2026" → "primeiro semestre de 2026". */
export function nomeDoSemestre(titulo?: string): string {
  const achado = titulo?.match(/(\d)S(\d{4})/);
  if (!achado) return '';
  return `${achado[1] === '1' ? 'primeiro' : 'segundo'} semestre de ${achado[2]}`;
}
